<template>
  <div>
    <h1>Contact en charge de la TLPE</h1>
    <span v-if="name">{{ name }}</span>
    <span v-if="address">
      <br />
      <span v-if="address">{{ address }}</span>
    </span>
    <span v-if="phone">
      <br />Tel:
      <a :href="'tel:' + phone">{{ phone }}</a>
    </span>
    <span v-if="mail">
      <br />Mail:
      <a :href="'mailto:' + mail">{{ mail }}</a>
    </span>
  </div>
</template>

<script>
export default {
  name: 'app-footer-contact',
  props: {
    configuration: Object
  },
  computed: {
    name () {
      return this.configuration.tlpeContactName
    },
    address () {
      return this.configuration.tlpeContactAddress
    },
    phone () {
      return this.configuration.tlpeContactPhone
    },
    mail () {
      return this.configuration.tlpeContactMail
    }
  }
}
</script>

<style scoped>
  h1 {
    font-weight: 700;
    font-size: 1.4rem;
    letter-spacing: normal;
  }

  a {
    color: rgba(255, 255, 255, 0.8);
    font-weight: normal;
    transition: all 0.3s ease;
  }

  a:hover {
    color: rgba(0, 0, 0, 0.5);
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer/app-footer-city-contact.vue